import { Box, Typography, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../../resources/strings/StringKeys';
import COLORS from '../../../../../resources/style/Themes';
import { Emergency } from '../../../../../models/Emergency/Emergency';

interface ChatHeaderProps {
  emergency: Emergency;
  onHide: () => void;
}

const ChatHeader = ({ emergency, onHide }: ChatHeaderProps) => {
  const { t } = useTranslation();

  const getIncidentTranslationKey = (incident: string): string => {
    const incidents: Record<string, string> = {
      'SOS Button': StringKeys.SOS_BUTTON,
      'Arc Flash': StringKeys.ARC_FLASH,
      'Head Impact': StringKeys.HEAD_IMPACT,
      'Dangerous Fall': StringKeys.DANGEROUS_FALL,
    };
    return incidents[incident] || '';
  };

  return (
    <Box
      sx={{
        backgroundColor: COLORS.SAFEGUARD_BLUE,
        color: COLORS.WHITE,
        borderRadius: '10px 10px 0 0',
        textAlign: 'center',
        position: 'relative',
        padding: 2,
        pl: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h6" id="chat-modal-title">
        {emergency.creator_first_name} {emergency.creator_last_name} -{' '}
        {t(getIncidentTranslationKey(emergency.incident))}
      </Typography>
      <IconButton
        sx={{ color: COLORS.WHITE, position: 'absolute', right: 8, top: 8 }}
        onClick={onHide}
      >
        &times;
      </IconButton>
      <Typography variant="body2">{emergency.creator_phone_number}</Typography>
    </Box>
  );
};

export default ChatHeader;
